module.exports = __webpack_public_path__ + "static/media/mrt_logo.85bd227c.png";